module.exports = new __parcel__URL__("github-code.0d21bbda.svg").toString();